import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbfb72e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base leave-container" }
const _hoisted_2 = { class: "footer-setting" }

import useSpaceApi from '@/composables/api/useSpaceApi'
import useAuth from '@/composables/api/useAuth'

export default /*#__PURE__*/_defineComponent({
  __name: 'LeavePopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  exitPath: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue', 'click-leave'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const { saveLogsLeaveButton } = useSpaceApi()
const { getAccessInfo } = useAuth()
const close = () => {
  emit('update:modelValue', !props.modelValue)
}
const leave = async () => {
  const { roomId, participantId } = getAccessInfo()
  await saveLogsLeaveButton(roomId || '', participantId || '')
  close()
  window.location.href = props.exitPath
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: `${_ctx.$t('leave')}`,
    open: __props.modelValue,
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-leave bg-red-500",
          onClick: leave
        }, _toDisplayString(_ctx.$t('leave-confirm-button')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          onClick: close
        }, _toDisplayString(_ctx.$t('leave-cancel')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('leave-message')) + " " + _toDisplayString(__props.exitPath), 1)
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})